import { render, staticRenderFns } from "./ProductsCards.vue?vue&type=template&id=72cbc0e2&scoped=true"
import script from "./ProductsCards.vue?vue&type=script&lang=js"
export * from "./ProductsCards.vue?vue&type=script&lang=js"
import style0 from "./ProductsCards.vue?vue&type=style&index=0&id=72cbc0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbc0e2",
  null
  
)

export default component.exports